export * from './upgrade';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
